// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_xBk","cls2":"LoswpTabsHero-cls2_4sA LoswpTabsHero-cls1_xBk"};